export default __webpack_public_path__ + "static/media/bokun-logo.6a727dc0.svg";